// src/components/Navbar.jsx
import React, { useState, useEffect } from "react";
import "../NavBar/Navbar.css";
import logo from "../../assets/logo.png";
import { Link } from "react-scroll";
import contactImg from "../../assets/contact.png";
import { FiMenu, FiX } from "react-icons/fi";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Scroll effect to toggle navbar background
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className={`custom-navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="navbar-container">
        {/* Logo */}
        <img src={logo} alt="Logo" className="logo" />

        {/* Desktop Menu */}
        <div className={`desktopMenu ${menuOpen ? "open" : ""}`}>
          <Link
            to="home"
            smooth={true}
            duration={500}
            spy={true}
            offset={-70}
            className="desktopMenuListItem"
            activeClass="active"
            onClick={() => setMenuOpen(false)}
          >
            Home
          </Link>
          <Link
            to="about"
            smooth={true}
            duration={500}
            spy={true}
            offset={-70}
            className="desktopMenuListItem"
            activeClass="active"
            onClick={() => setMenuOpen(false)}
          >
            About
          </Link>
          <Link
            to="academics"
            smooth={true}
            duration={500}
            spy={true}
            offset={-70}
            className="desktopMenuListItem"
            activeClass="active"
            onClick={() => setMenuOpen(false)}
          >
            Academics
          </Link>
          <Link
            to="work"
            smooth={true}
            duration={500}
            spy={true}
            offset={-70}
            className="desktopMenuListItem"
            activeClass="active"
            onClick={() => setMenuOpen(false)}
          >
            Work
          </Link>
          <Link
            to="service"
            smooth={true}
            duration={500}
            spy={true}
            offset={-70}
            className="desktopMenuListItem"
            activeClass="active"
            onClick={() => setMenuOpen(false)}
          >
            Service
          </Link>
        </div>

        {/* Contact Button */}
        <Link
          to="contact"
          smooth={true}
          duration={500}
          spy={true}
          offset={-70}
          className="desktopMenuBtn"
          onClick={() => setMenuOpen(false)}
        >
          <img src={contactImg} alt="Contact" className="desktopMenuImg" />
          Contact Me
        </Link>

        {/* Mobile Menu Icon */}
        <div className="menuIcon" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FiX size={25} /> : <FiMenu size={25} />}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
